export default __webpack_public_path__ + "static/media/linkedin.7d21df2a.svg";